import axios from 'axios';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { checkActivityFunctions } from 'single-spa';
import _ from 'lodash';
import PubSub from './pub-sub';
import { EVENT_SHOW_UPDATE_BANNER } from './events';
import { fetchMfeConfig } from './config';
import GscopeMfeTools from './tools';
import { importMapUrl } from './import-map';

const appBridgePubSub = new PubSub('@gscope-mfe/app-bridge');

let currentImportMap = null;
let latestImportMap = null;

const mfeModuleDepMap = {};
const modulesWithUpdates = {};

function normalizeUrl(url) {
    return url.startsWith('//') ? `${window.location.protocol}${url}` : url;
}
function deNormalizeUrl(url) {
    return url.startsWith('http:') ? url.substr(5) : url;
}
function getScope(parentUrl, importMap) {
    if (!importMap || !parentUrl) {
        return null;
    }
    const { scopes: allScopes = {} } = importMap;
    return allScopes[normalizeUrl(parentUrl)] || allScopes[deNormalizeUrl(parentUrl)] || null;
}
function buildModuleTree(node, importMap, parentUrl = null) {
    const { id, deps } = node;
    const name = resolveUrlToModule(id, importMap, parentUrl);
    return { id, name, deps: deps.map((d) => buildModuleTree(d, importMap, node.id)) };
}
function resolveUrlToModule(url, importMap, parentUrl = null) {
    if (!importMap) {
        return null;
    }
    const { imports } = importMap;
    const currentScope = getScope(parentUrl, importMap) || {};
    const foundEntryInScopes = Object.entries(currentScope).find(([, moduleUrl]) => {
        return normalizeUrl(moduleUrl) === url;
    });
    if (foundEntryInScopes) {
        return foundEntryInScopes[0];
    }

    const foundEntryInImports = Object.entries(imports).find(([, moduleUrl]) => {
        return normalizeUrl(moduleUrl) === url;
    });
    if (foundEntryInImports) {
        return foundEntryInImports[0];
    }
    return null;
}
function hasUpdates(node, importMap, parentUrl = null) {
    if (!importMap) {
        return false;
    }
    const { imports } = importMap;
    const currentScope = getScope(parentUrl, importMap);
    if (currentScope && _.has(currentScope, node.name)) {
        return normalizeUrl(currentScope[node.name]) !== node.id;
    }
    return normalizeUrl(imports[node.name]) !== node.id || node.deps.some((d) => hasUpdates(d, importMap, node.id));
}
async function initializeNudge() {
    const mfeConfig = await fetchMfeConfig();
    const { updateInterval } = mfeConfig;

    setTimeout(function updateCheckInterval() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const [currentMfeApp] = checkActivityFunctions();
        const promises = [];
        if (currentMfeApp && currentImportMap && !mfeModuleDepMap[currentMfeApp]) {
            promises.push(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                System.getModuleTree(currentMfeApp).then((fileTree) => {
                    mfeModuleDepMap[currentMfeApp] = buildModuleTree(fileTree, currentImportMap);
                }),
            );
        }
        Promise.all(promises).finally(() => {
            setTimeout(updateCheckInterval, updateInterval);
        });
    }, updateInterval);
    setTimeout(function updateImportMap() {
        const moduleOverrides = GscopeMfeTools.getModuleOverrides();
        axios
            .get(importMapUrl, {
                ...(moduleOverrides
                    ? {
                          params: {
                              importMapOverrides: JSON.stringify(moduleOverrides),
                          },
                      }
                    : {}),
            })
            .then(({ data }) => {
                latestImportMap = data;
                if (!currentImportMap) {
                    currentImportMap = latestImportMap;
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const [currentMfeApp] = checkActivityFunctions();
                if (currentMfeApp && mfeModuleDepMap[currentMfeApp]) {
                    const previousDepMap = mfeModuleDepMap[currentMfeApp];
                    if (hasUpdates(previousDepMap, latestImportMap)) {
                        appBridgePubSub.publishStateUpdate({
                            event: EVENT_SHOW_UPDATE_BANNER,
                            data: true,
                        });
                        modulesWithUpdates[currentMfeApp] = true;
                    }
                }
                setTimeout(updateImportMap, updateInterval);
            });
    }, updateInterval);
    window.addEventListener('single-spa:before-routing-event', () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const [currentMfeApp] = checkActivityFunctions();
        if (currentMfeApp && modulesWithUpdates[currentMfeApp]) {
            appBridgePubSub.publishStateUpdate({
                event: EVENT_SHOW_UPDATE_BANNER,
                data: true,
            });
            return;
        }
        appBridgePubSub.publishStateUpdate({
            event: EVENT_SHOW_UPDATE_BANNER,
            data: false,
        });
    });
}
initializeNudge();
